import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-basic-button_unlock",
  "use": "icon-basic-button_unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-basic-button_unlock\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M7.798 9.283c-.05-.29-.123-.724-.22-1.303-.456-2.692 1.502-5.302 4.372-5.83 2.87-.527 5.567 1.228 6.023 3.92M12.5 14.196v3.925\" stroke-linecap=\"round\" /><rect x=\"3.75\" y=\"9.45\" width=\"17.5\" height=\"12.8\" rx=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol